import SquaredBox from '@/components/ui/squared-box';
import Header from './pbm-header';
import { ArrowPrevIcon } from '@/components/icons/arrow-prev';
import { PbmEmbeddedShell } from './pbm-embedded-shell';

export default function BoxError({
  onBack,
  embedded,
  message,
}: Readonly<{
  onBack: () => void;
  embedded?: boolean;
  /** When set (e.g. API business error F803), shown instead of the default validation error copy. */
  message?: string;
}>) {
  const inner = (
    <>
      <p className="text-center font-semibold text-red-500">
        {message?.trim()
          ? message.trim()
          : 'Ocorreu um erro ao validar seu CPF. Tente novamente.'}
      </p>
      <button
        type="button"
        onClick={onBack}
        className="mt-4 flex items-center gap-1 self-start text-sm font-medium text-accent"
      >
        <ArrowPrevIcon className="h-5 w-5" />
        Voltar
      </button>
    </>
  );

  if (embedded) {
    return <PbmEmbeddedShell className="border-dashed">{inner}</PbmEmbeddedShell>;
  }

  return (
    <SquaredBox>
      <Header />
      <SquaredBox.Content className="items-center justify-center text-center">
        {inner}
      </SquaredBox.Content>
    </SquaredBox>
  );
}
